/**
 * Created by kuyarawa on 01/08/18.
 */

const CONFIG = {
  env:'local',
  // apiUrl: 'http://localhost:3000/web',
  apiUrl: 'https://the-api-prod-new.tadotv.com/web',
  apiWebsiteUrl: 'https://the-api-prod-new.tadotv.com/website',
  apiTadoUrl: 'https://the-api-prod-new.tadotv.com/',
  appName1: 'TADO',
  appName2: 'Dashboard',
  appNameAbbr1: 'T',
  appNameAbbr2: 'D',
  hlsS3Url: 'https://s3-ap-southeast-1.amazonaws.com/tado-hls/',
  s3Url: 'https://s3.ap-southeast-1.amazonaws.com/tado-tv/',
  playstoreUrl:'https://play.google.com/store/apps/details?id=com.tado.tv',
  appstoreUrl:'https://itunes.apple.com/id/app/tadotv-interactive-video/id1439414985?mt=8',
  shareUrl:'https://share.tadotv.com/development/',
  logDebug:true,
  studioUrl: 'http://localhost:3001/',
  baseUrl:'http://tado-tv-web-development.s3-website-ap-southeast-1.amazonaws.com/',

  //apps flyer banner
  bannerSubDomain:'go',
  bannerTitle:'TADOtv - Interactive Video Content',
  bannerSubTitle:'Tonton video interaktif lainnya dengan mendownload aplikasi TADOtv',
  bannerOnelinkId:'3n3X',
  bannerMediaSource:'Web_Player',
  bannerCampaign:'Web_Player_Install',
  bannerAdset:'',
  bannerDeeplink:'',

  //facebook pixel
  pixelId:'771559003226217',

  //MLI
  mli_id:69,
  mli_url:'https://www.majelislucuindonesia.com/news/18',

  sentry_dsn:'http://bbf5d523cfd74917a330214223296e74@log.tadotv.com/4',
}

export default CONFIG
